mutation TravelPolicyUpdate($input: TravelPolicyUpdateInput!) {
  travelPolicyUpdate(input: $input) {
    travelPolicy {
      id
      _rowTimestamp
      _isUpdatable
      _isDeletable
      description
      currencyId
      companyCurrency {
        id
        isoCode
        name
      }
      isDefaultCustomizable
      isContractual
      isCompanion
      companionTickets
      companionAmount
      isEconomyClassAllowed
      isPremiumClassAllowed
      isBusinessClassAllowed
      isFirstClassAllowed
      isCharterClassAllowed
      travelPolicyAllowancesByTravelPolicyId(orderBy: SORT_ORDER_ASC) {
        nodes {
          id
          _rowTimestamp
          _isUpdatable
          _isDeletable
          expenditureTypeId
          expenditureType {
            expenditureType
          }
          country1Id
          country2Id
          country1 {
            country
          }
          country2 {
            country
          }
          stateRegion1Id
          stateRegion2Id
          stateRegion1 {
            stateRegion
          }
          stateRegion2 {
            stateRegion
          }
          policyAllowance
          policyMiles
          isAllowanceCustomizable
        }
        totalCount
      }
    }
  }
}
